import { Tooltip } from '@mui/material';
import React from 'react';
import { Modal2 } from '../..';
import useIsMobile from '../../hooks/useIsMobile';
import { Modal2Props } from '../Modal2';
type RenderCommon = {
  renderContent: ({
    hide
  }) => React.ReactElement<any, any>;
};
type RenderSpecific = {
  renderMobileContent: ({
    hide
  }) => React.ReactElement<any, any>;
  renderDesktopContent: ({
    hide
  }) => React.ReactElement<any, any>;
};
const RENDER_NOTHING = () => null;
type Props = Pick<Modal2Props, 'show' | 'setShow' | 'render' | 'desktopVariant' | 'mobileVariant'>;
export type ResponsiveTooltipProps<P extends Props> = {
  ModalProps?: Omit<P, 'show' | 'setShow' | 'render'>;
  component?: 'div' | 'span';
  children: React.ReactElement<any, any> | string;
  modalComponent?: React.Component<P, any> | React.FC<P>;
} & (RenderCommon | RenderSpecific);
const ResponsiveTooltip = function <P extends Props = Modal2Props>({
  children,
  component,
  modalComponent,
  ModalProps,
  ...props
}: ResponsiveTooltipProps<P>) {
  const isMobile = useIsMobile();
  const [show, setShow] = React.useState(false);
  const Comp = component || 'span';
  const Modal: React.FC<Props> = (modalComponent ?? Modal2) as unknown as React.FC<P>;
  if (isMobile) {
    const renderMobile = 'renderMobileContent' in props ? props.renderMobileContent : props.renderContent;
    return <>
        <Comp onClick={() => {
        setShow(true);
      }} style={{
        cursor: 'pointer'
      }}>
          {children}
        </Comp>

        <Modal desktopVariant="none" mobileVariant="modal" {...ModalProps || {}} show={show} setShow={setShow} render={renderMobile || RENDER_NOTHING} />
      </>;
  } else {
    const renderDesktop = 'renderDesktopContent' in props ? props.renderDesktopContent : props.renderContent;
    return <Tooltip title={renderDesktop ? renderDesktop({
      hide: undefined
    }) : undefined}>
        <Comp>{children}</Comp>
      </Tooltip>;
  }
};
export default ResponsiveTooltip;